import React from "react";
import editIcon from "../../assets/svg/edit_white.svg";

const EditConfirmModal = ({ onConfirm, onCancel }) => {
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1050,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "32px",
      borderRadius: "24px",
      width: "400px",
      textAlign: "center",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    },
    iconOuter: {
      width: "64px",
      height: "64px",
      borderRadius: "50%",
      backgroundColor: "#E5F6EB",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto 24px auto",
    },
    iconInner: {
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      backgroundColor: "#278F49",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    title: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#172b4d",
      marginBottom: "8px",
      fontFamily: "'Epilogue', sans-serif",
    },
    subtitle: {
      fontSize: "14px",
      color: "#8790A1",
      marginBottom: "28px",
      fontWeight: "400",
      fontFamily: "'Epilogue', sans-serif",
    },
    buttonsContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "16px",
    },
    btnCancel: {
      padding: "12px 24px",
      borderRadius: "50px",
      border: "1px solid #E5E5E5",
      backgroundColor: "#FFFFFF",
      color: "#172b4d",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      fontFamily: "'Epilogue', sans-serif",
      flex: 1,
      transition: "background-color 0.2s",
    },
    btnConfirm: {
      padding: "12px 24px",
      borderRadius: "50px",
      border: "none",
      backgroundColor: "#278F49",
      color: "#FFFFFF",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      fontFamily: "'Epilogue', sans-serif",
      flex: 1,
      transition: "background-color 0.2s",
    },
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        {/* Icon */}
        <div style={modalStyle.iconOuter}>
          <div style={modalStyle.iconInner}>
            <img src={editIcon} alt="edit" width="20" height="20" />
          </div>
        </div>

        {/* Text */}
        <div style={modalStyle.title}>Edit Record?</div>
        <div style={modalStyle.subtitle}>Are you sure want to edit this record?</div>

        {/* Buttons */}
        <div style={modalStyle.buttonsContainer}>
          <button style={modalStyle.btnCancel} onClick={onCancel} onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#F9F9F9")} onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FFFFFF")}>
            No, I don't
          </button>
          <button style={modalStyle.btnConfirm} onClick={onConfirm} onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#217D3F")} onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#278F49")}>
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditConfirmModal;
